<!--<div class="container-fluid" id="divloginPanel">
  <div class="row">
    <div class="col-4">
      <div class="form">
        <div class="divlogo">
          <h3>
            <img src="../../assets/Images/Logo.png" style="width:60%" alt="SesameWms Logo" />
          </h3>
        </div>-->
<!--<img src="../../assets/Images/tfo_logo.png" />-->
<!--<div>
          <div class="row">
            <div class="col-sm-12">
              <form class="register-form" id="register-form">
                <div class="splogin"><span>Change Password</span></div>

                <input type="password" placeholder="New Password" name="Password" [(ngModel)]="Password" maxlength="{{modelItem.PasswordMaxlength}}"
                       pattern="{{modelItem.PasswordFormat}}" autocomplete="off" required />
                <button (click)="ChangePassword()">Reset</button>
                <p class="message">Click to <a [routerLink]='["/login"]'>Login</a></p>
              </form>

            </div>
          </div>

        </div>
      </div>

    </div>
    <div class="col-8">
      <div class="divRightPanel"></div>

    </div>

  </div>
</div>-->



<div class="container-fluid p-0">
  <div class="row g-0">
    <div class="col-xl-9">
      <div class="auth-full-bg pt-lg-5 p-4">
        <div class="w-100">
          <div class="bg-overlay" style="background: url(../../assets/Layout/images/illustration1.svg) no-repeat center !important;"></div>

        </div>
      </div>
    </div>

    <!-- end col -->

    <div class="col-xl-3">
      <div class="auth-full-page-content p-md-5 p-4">
        <div class="w-100">
          <div class="d-flex flex-column h-100">
            <div class="mb-4 mb-md-5">
              <a href="index.html" class="d-block auth-logo">
                <img src="assets/Layout/images/logo-dark.png" alt="" height="28" class="auth-logo-dark">
                <img src="assets/Layout/images/logo-light.png" alt="" height="28" class="auth-logo-light">
              </a>
            </div>
            <div class="my-auto">
              <div id="divReset">
                <h5 class="text-primary">Change Password</h5>
                <p class="text-muted">Update new Password with SesameWms.</p>
              </div>
              <div class="mt-4">
                <form class="register-form" id="register-form">
                  <div class="mb-3">
                    <label for="password" class="form-label">Password</label><em>*</em>
                    <div class="input-group auth-pass-inputgroup">
                      <input type="password" class="form-control" id="password" placeholder="Password" name="Password" [(ngModel)]="Password" maxlength="{{modelItem.PasswordMaxlength}}" pattern="{{modelItem.PasswordFormat}}" autocomplete="off" required />
                      <button class="btn btn-light" type="button" id="password-addon" (click)="updateType()"><i class="far fa-eye-slash"></i></button>
                    </div>

                  </div>

                  <div class="mt-3 d-grid">
                    <button type="button" class="btn btn-primary waves-effect waves-light" (click)="ChangePassword()">Reset</button>
                  </div>
                  <div class="mt-5 text-center">
                    <p><a href="javascript:void(0)" class="text-muted" [routerLink]='["/login"]'>Sign In here</a><!--<a href="auth-login-2.html" class="fw-medium text-primary"> </a>--> </p>
                  </div>

                </form>
              </div>
            </div>
            <div class="mt-4 mt-md-5 text-center">
              <p class="mb-0">
                ©
                <script>document.write(new Date().getFullYear())</script>2021 SesameWms
                <i class="mdi mdi-heart text-danger" style="display:none"></i> by AAAS
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end col -->
  </div>
  <!-- end row -->
</div>
